import React, { useEffect, useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import { Chart as ChartJS } from "chart.js/auto";
import api from "../utils/api";
import { motion } from "framer-motion";

function Analytics() {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  // 🧩 جلب القضايا من الـ API
  useEffect(() => {
    const fetchCases = async () => {
      try {
        const res = await api.get("/cases?page=1&limit=1000"); // نجلب عدد كبير من القضايا للتحليل
        const data = Array.isArray(res.data.cases)
          ? res.data.cases
          : Array.isArray(res.data)
          ? res.data
          : [];
        setCases(data);
      } catch (err) {
        console.error("❌ فشل تحميل القضايا:", err);
        setCases([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCases();
  }, []);

  // 🟡 حساب الإيرادات الشهرية
  const monthlyRevenue = {};
  (cases || []).forEach((c) => {
    const date = c.startDate || c.createdAt;
    if (!date) return;
    const month = new Date(date).toLocaleString("ar-EG", { month: "short" });
    monthlyRevenue[month] = (monthlyRevenue[month] || 0) + (Number(c.price) || 0);
  });

  // ⚖️ حساب أنواع القضايا
  const typeCount = {};
  (cases || []).forEach((c) => {
    const type = c.type || "غير محدد";
    typeCount[type] = (typeCount[type] || 0) + 1;
  });

  const colors = [
    "#facc15",
    "#22c55e",
    "#3b82f6",
    "#ef4444",
    "#a855f7",
    "#ec4899",
    "#14b8a6",
  ];

  // ⏳ شاشة التحميل المؤقتة
  if (loading) {
    return (
      <div className="p-8 text-center text-yellow-400 animate-pulse">
        جاري تحميل التحليلات...
      </div>
    );
  }

  return (
    <motion.div
      className="grid md:grid-cols-2 gap-8 p-6 bg-gradient-to-br from-gray-900 via-black to-gray-800 min-h-screen rounded-2xl"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      {/* 💰 الإيرادات الشهرية */}
      <motion.div
        className="bg-gray-900 border border-yellow-500 rounded-2xl p-6 shadow-xl hover:shadow-yellow-500/40 transition-all"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <h3 className="text-2xl font-bold mb-4 text-yellow-400 flex items-center gap-2">
          💰 الإيرادات الشهرية
        </h3>

        {Object.keys(monthlyRevenue).length > 0 ? (
          <Bar
            data={{
              labels: Object.keys(monthlyRevenue),
              datasets: [
                {
                  label: "الإيرادات (ج.م)",
                  data: Object.values(monthlyRevenue),
                  backgroundColor: "#facc15",
                  borderRadius: 10,
                },
              ],
            }}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  labels: { color: "#fff", font: { size: 13 } },
                },
              },
              scales: {
                x: { ticks: { color: "#facc15" } },
                y: { ticks: { color: "#facc15" } },
              },
            }}
          />
        ) : (
          <p className="text-gray-400 text-center mt-10">لا توجد بيانات إيرادات بعد</p>
        )}
      </motion.div>

      {/* ⚖️ أنواع القضايا */}
      <motion.div
        className="bg-gray-900 border border-yellow-500 rounded-2xl p-6 shadow-xl hover:shadow-yellow-500/40 transition-all"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <h3 className="text-2xl font-bold mb-4 text-yellow-400 flex items-center gap-2">
          ⚖️ أنواع القضايا
        </h3>

        {Object.keys(typeCount).length > 0 ? (
          <Pie
            data={{
              labels: Object.keys(typeCount),
              datasets: [
                {
                  data: Object.values(typeCount),
                  backgroundColor: colors,
                  borderColor: "#111827",
                  borderWidth: 2,
                },
              ],
            }}
            options={{
              plugins: {
                legend: {
                  labels: { color: "#fff", font: { size: 14 } },
                },
              },
            }}
          />
        ) : (
          <p className="text-gray-400 text-center mt-10">لا توجد قضايا بعد</p>
        )}
      </motion.div>
    </motion.div>
  );
}

export default Analytics;
